<template>
  <div class="mt-4">
    <table v-if="propEProtocolos.length"
           class="table table-sm tabela-custom">
      <thead class="thead-custom">
        <tr>
          <th>Número do protocolo</th>
          <th>Status</th>
          <th class="col-acao">
            Ação
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="item in dataTable"
            :key="item.id">
          <td>{{ item.requirement_id || 'Não informado' }}</td>
          <td class="text-truncate"
              :title="statusLabels[item.status] || item.status || 'Não informado'">
            {{ statusLabels[item.status] || item.status || 'Não informado' }}
          </td>
          <td class="col-acao">
            <div class="acoes-btns">
              <button
                class="btn btn-sm btn-outline-primary btn-nowrap"
                @click="verDetalhes(item)">
                Detalhes
              </button>

              <button
                class="btn btn-sm btn-primary btn-nowrap btn-com-icone"
                @click="acessar(item.hash)">
                <IconSvg icon="openInNew"
                         class="icon--sm" />
                Acessar protocolo
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else
       class="text-center">
      Nenhum protocolo foi encontrado.
    </p>
    <EProtocoloModal ref="modalDetalhes"
                     :protocolo="selectedItem" />
  </div>
</template>

<script>
  /* components */
  import EProtocoloModal from '@/components/SofiaRei/EProtocolo/EProtocoloModal'

  /* services */
  import EProtocoloService from '@/services/EProtocoloService'

  export default {
    name: "EProtocoloTable",
    components: {
      EProtocoloModal
    },
    props: {
      propEProtocolos: {type: Array, default: () => []}
    },
    data () {
      return {
        dataTable: [],
        selectedItem: null,
        statusLabels: {
          waiting_approval_for_additional_services: 'Aguardando manifestação de orgão externo',
          request_received: 'Em andamento',
          transferred_to_another_notary: 'Transferido para outro cartório',
          payment_made: 'Pagamento realizado',
          waiting_for_payment: 'Pagamento pendente',
          requirement_note_answered: 'Nota de exigência respondida',
          budget_response: 'Resposta de orçamento',
          canceled: 'Cancelado',
          waiting_for_response_requirement_note: 'Nota de exigência pendente',
          signature_completed: 'Assinatura concluída',
          accepted_devolution: 'Devolução aceita',
          rejected_devolution: 'Devolução recusada',
          send_for_budget: 'Encaminhado para orçamento',
          devolved: 'Devolvido',
          waiting_third_party_signature: 'Aguardando assinatura de terceiro'
        }
      }
    },
    watch: {
      propEProtocolos: {
        handler (novoValor) {
          this.dataTable = novoValor
        },
        immediate: false,
        deep: true,
      },
    },
    methods: {
      async verDetalhes (item) {
        const response = await EProtocoloService.verDetalhes(item.hash)
        this.selectedItem = {...response.data.detalhes.data, hash: item.hash, statusLabels: this.statusLabels[item.status]}

        this.$nextTick(() => {
          this.$refs.modalDetalhes.abrirModal()
        })
      },
      acessar (hash) {
        window.open(
          `https://protocoloh.registrocivil.org.br/requerimento/detalhe/${hash}`,
          '_blank'
        )
      }
    },
  }
</script>

<style scoped>

.thead-custom {
  background-color: #01bfa5;
}

.tabela-custom {
  width: 100%;
  table-layout: fixed;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}

.tabela-custom th,
.tabela-custom td {
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-left: none;
  border-right: none;
}

.col-acao {
  width: 260px;
  padding-left: 16px;
  padding-right: 16px;
}

.acoes-btns {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-nowrap {
  white-space: nowrap;
}

.btn-com-icone {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-com-icone .icon--sm {
  flex-shrink: 0;
}

.btn-primary {
  background-color: #074f7f;
  border-color: #074f7f;
}

.btn-primary:hover {
  background-color: #053a5c;
  border-color: #053a5c;
}

.btn-outline-primary {
  color: #074f7f;
  border-color: #074f7f;
}

.btn-outline-primary:hover {
  background-color: #074f7f;
  color: white;
}

</style>
